var getBlurSize = function getBlurSize(position, side) {
  if (position === 'default') {
    return 90;
  }
  return side === 'left' ? 44 : 58;
};
var calculateOffset = function calculateOffset(left, wrapperRef, position, side) {
  var offset = getBlurSize(position, side);
  var _ref = wrapperRef.current || {},
    _ref$scrollWidth = _ref.scrollWidth,
    scrollWidth = _ref$scrollWidth === void 0 ? 0 : _ref$scrollWidth,
    _ref$offsetWidth = _ref.offsetWidth,
    offsetWidth = _ref$offsetWidth === void 0 ? 0 : _ref$offsetWidth;
  var factor = Math.max(offset - left, offset / 2) * 2 / offset;
  return side === 'left' ? offset * Math.min(left * factor / offset, 1) : offset * Math.min((scrollWidth - left - offsetWidth) * factor / offset, 1);
};
export var calculateBlurOffset = function calculateBlurOffset(left, wrapperRef, position) {
  return {
    left: calculateOffset(left, wrapperRef, position, 'left'),
    right: calculateOffset(left, wrapperRef, position, 'right')
  };
};